<template>
    <div>
        <v-tabs :value="controller.model.getActiveTabIndex()" background-color="transparent" class="denser-tabs"
                slider-size="4">
            <v-tabs-slider
                :color="controller.model.isTabError(controller.model.getSelectedLocaleCode()) ? 'error' : 'primary'"></v-tabs-slider>
            <v-tab
                v-for="(language, index) in controller.model.languages"
                :key="language.code"
                :color="controller.model.tabHasContent(language.code) ? 'main' : 'g4'"
                :class="controller.model.isTabError(language.code)
              ? 'error--text'
              : controller.model.getActiveTabIndex() === index
                  ? 'primary--text'
                  : controller.model.tabHasContent(language.code)
                      ? 'main--text'
                      : 'g4--text'"
                @click="controller.setSelectedLocaleCode(language.code)"
                tip
            >
                <v-tooltip top open-delay="250">
                    <template v-slot:activator="{ on, attrs }">
            <span class="caption font-weight-medium"
                  v-bind="attrs"
                  v-on="on">
                {{ formatLanguageLabel({name: language.code.substr(0, 2), code: language.code}) }}
            </span>
                    </template>
                    <span>{{ formatLanguageLabel({name: $t(language.name), code: language.code}) }}</span>
                </v-tooltip>
            </v-tab>
        </v-tabs>

        <div class="compact-fields">
            <text-field
                ref="subjectTextField"
                :value="controller.model.getSubject()"
                :disabled="!controller.model.canEditTemplate()"
                :error-messages="controller.model.getSubjectError()"
                hide-details
                :placeholder="controller.model.getTitleText()"
                test-id="email-template-dialog-subject"
                class="pt-0"
                @input="setSubject($event)"
                @click="emitFocusInfo('subject')"
                @keyup="emitFocusInfo('subject')"
            ></text-field>

            <RichTextEditor
                ref="richTextEditor"
                toolbar="#email-automation-content-toolbar"
                :content="controller.model.getContent()"
                :disabled="!controller.model.canEditTemplate()"
                test-id="email-template-dialog-content"
                :error-message="controller.model.getContentError()"
                @input="controller.setContent($event)"
                @focus="emitFocusInfo('content')"
            />
        </div>
    </div>
</template>

<script>
import {ref} from "@vue/composition-api";
import RichTextEditor from "../../../components/RichTextEditor/RichTextEditor";
import Controller from "./controller"
import {formatLanguageLabel} from '../../../helpers/formatting'

export default {
    name: "EditTemplateEmail",
    methods: {formatLanguageLabel},
    components: {
        RichTextEditor
    },
    props: {
        controller: {
            type: Controller,
            required: true
        }
    },
    setup(props, ctx) {
        const subjectTextField = ref(null);
        const emitFocusInfo = (fieldName) => {
            let cursorIndex = null
            if (fieldName === "subject") {
                const subjectField = subjectTextField.value.$refs.textField.$refs.input;
                cursorIndex = subjectField.selectionStart;

            }
            ctx.emit('focusInfo', {fieldName: fieldName, cursorIndex: cursorIndex})
        }

        const setSubject = (event) => {
            props.controller.setSubject(event)
            emitFocusInfo("subject")
        }

        return {
            subjectTextField,
            emitFocusInfo,
            setSubject,
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .v-tab.error--text {
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 12px;
        right: 12px;
        height: 2px;
        background-color: var(--v-error-base);
    }
}
</style>